import React, {useEffect, useState} from 'react';
import {Link} from 'react-router-dom';
import Button from '../../components/ui/Button';
import Card from '../../components/ui/Card';
import Icon from '../../components/ui/Icon';
import Thumb from '../../components/ui/Thumb';
import {api} from '../../lib/api';
import {featuredProject, galleryCategories, galleryProjects} from '../../data/mock';
import styles from './Gallery.module.scss';

function ProjectCard ({project}) {
    const isFeaturedCard = Boolean(project.featured);
    return (
        <Card
            as={Link}
            to={`/lab/${project.id}`}
            className={[styles.card, isFeaturedCard ? styles.cardBig : ''].join(' ')}
            pad={false}
        >
            <div className={styles.cardThumb}>
                <Thumb theme={project.thumb} ratio={isFeaturedCard ? '4 / 3' : '16 / 10'} />
                {isFeaturedCard && (
                    <span className={styles.rating}><Icon name="star" size={14} /> 1.2k</span>
                )}
            </div>
            <div className={styles.cardBody}>
                <h3 className={styles.cardTitle}>{project.title}</h3>
                <div className={styles.cardMeta}>
                    <span className={styles.author}>{project.author}</span>
                    <span className={styles.stats}>
                        <span className={styles.stat}><Icon name="star" size={15} /> {project.likes}</span>
                        {project.remixes != null && (
                            <span className={styles.stat}><Icon name="share" size={15} /> {project.remixes}</span>
                        )}
                    </span>
                </div>
            </div>
        </Card>
    );
}

export default function Gallery () {
    const [active, setActive] = useState('games');
    const [featured, setFeatured] = useState(featuredProject);
    const [categories, setCategories] = useState(galleryCategories);
    const [projects, setProjects] = useState(galleryProjects);
    const [source, setSource] = useState('local');

    useEffect(() => {
        let alive = true;
        api.galleryMeta().then(data => {
            if (!alive) return;
            if (data.featuredProject) setFeatured(data.featuredProject);
            if (data.categories?.length) setCategories(data.categories);
        }).catch(() => {});
        return () => {
            alive = false;
        };
    }, []);

    useEffect(() => {
        let alive = true;
        api.listProjects(active).then(({projects: remoteProjects}) => {
            if (!alive) return;
            setProjects(remoteProjects.map(p => ({
                id: p.id,
                title: p.title,
                author: p.user_id === 'u_demo' ? '@小码探险家' : `@${p.user_id}`,
                likes: p.likes,
                remixes: p.remixes,
                thumb: p.thumbnail || 'space'
            })));
            setSource('backend');
        }).catch(() => {
            if (!alive) return;
            setProjects(galleryProjects);
            setSource('local');
        });
        return () => {
            alive = false;
        };
    }, [active]);

    return (
        <div className={`cq-container ${styles.page}`}>
            {/* 本周之星 */}
            <section className={styles.featured}>
                <div className={styles.featuredText}>
                    <span className={styles.featuredTag}>
                        <Icon name="star" size={16} /> {featured.tag} · {source === 'backend' ? '后端数据' : '演示数据'}
                    </span>
                    <h1 className={styles.featuredTitle}>{featured.title}</h1>
                    <p className={styles.featuredAuthor}>作者 {featured.author}</p>
                    <Button variant="soft" size="lg" iconLeft={<Icon name="play" size={20} />} to={featured.id ? `/lab/${featured.id}` : '/gallery'}>
                        立即游玩
                    </Button>
                </div>
                <div className={styles.featuredArt}>
                    <Thumb theme={featured.thumb} ratio="16 / 10" />
                </div>
            </section>

            {/* 分类标签 */}
            <div className={styles.tabs}>
                {categories.map(c => (
                    <button
                        key={c.id}
                        className={[
                            styles.tab,
                            styles[`tab_${c.color}`],
                            active === c.id ? styles.tabActive : ''
                        ].join(' ')}
                        onClick={() => setActive(c.id)}
                    >
                        <Icon name={c.icon} size={18} /> {c.label}
                    </button>
                ))}
            </div>

            {/* 作品网格 */}
            <div className={styles.grid}>
                {projects.map(p => (
                    <ProjectCard key={p.id} project={p} />
                ))}
            </div>

            <button className={styles.fab} aria-label="上传我的作品">
                <Icon name="plus" size={26} />
            </button>
        </div>
    );
}
